import { DisplayFormErrors } from "melco-shared-logic";
import { QueryObserverResult } from "react-query";
import { Col, Row, Tabs, TabsProps } from "melco-ui";

import { DebugForm } from "../../form/DebugForm";
import { Drawer as DrawerType } from "../../../hooks/drawer/useGenericDrawer";
import { useRef, useState } from "react";
import { DashboardFilter } from "../DashboardFilter";
import { Charts } from "../charts/Charts";
import { UsersWizardsDrawer } from "../drawer/UsersWizardsDrawer";
import { useAddRemoveWizards } from "../../../hooks/dashboard/useAddRemoveWizard";

type DisplayUserWizardFormProps = {
  //  userWizards: MelcoCoreModelsGenericList1MelcoCoreModelsUserWizardListItem;
  refetch?: () => Promise<QueryObserverResult<any, unknown>>;
  selectedUserId: string;
  referencesWizardDrawer: DrawerType;
  onCloseWizardsDrawer: () => void;
};

export const DisplayUserWizardForm: React.FC<DisplayUserWizardFormProps> = ({
  onCloseWizardsDrawer,
  referencesWizardDrawer,
}) => {
  const [, setSelectedWizardByUser] = useState<string>("");

  const onSelectWizardByUser = (wizard: string) => {
    setSelectedWizardByUser(wizard);
  };
  const ref = useRef<HTMLIFrameElement>(null);
  // const [height, setHeight] = useState('0px');

  const onLoad = () => { };

  let { wizards } = useAddRemoveWizards();

  const [startTimeStamp, setStartTimeStamp] = useState();
  const [endTimeStamp, setEndTimeStamp] = useState();
  const [selectedProductCode, setSelectedProductCode] = useState();
  //console.log(wizards)

  let tabsTypeDashboard: TabsProps["items"] = [];
  let wizardsWithTypeDashboard = wizards?.filter((w) => w.type === "DASHBOARD");
  let wizardsWithTypeApi = wizards?.filter((w) => w.type === "API");
  tabsTypeDashboard = wizardsWithTypeDashboard
    ? wizardsWithTypeDashboard.map((w, i) => {
      return {
        key: w.id ? w.id + "" : i + "",
        label: w.name,
        children: (
          <div style={{ marginLeft: "0px" }}>
            <div
              tabIndex={i}
              style={{
                height: "100%",
                minHeight: "100%",
                position: "relative",
                left: "-99px",
              }}
            >
              <iframe
                title={`Wizard-${w.name}-${i}`}
                style={{ minHeight: "800px", height: "100%", border: "none" }}
                width={"100%"}
                onLoad={onLoad}
                ref={ref}
                id="element-iframe"
                className="w-full"
                src={w.url ?? ""}
              ></iframe>
            </div>
          </div>
        ),
      };
    })
    : [];

  let tabTypeAPI =
    wizardsWithTypeApi && wizardsWithTypeApi.length > 0
      ? [
        {
          key: "typeapi",
          label: "Melco Cloud",
          children: (
            <>
              <div>
                <Row>
                  <Col
                    xs={24}
                    xl={24}
                    md={24}
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    {wizards && wizards.length > 0 && (
                      <DashboardFilter
                        onFiltersChange={(v: any) => {
                          setStartTimeStamp(v?.startTimeStamp);
                          setEndTimeStamp(v?.endTimeStamp);
                          setSelectedProductCode(v?.selectedProductCode);
                          console.log(v);
                        }}
                      />
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col xs={24} xl={24} md={24}>
                    <Charts
                      startTimeStamp={startTimeStamp}
                      endTimeStamp={endTimeStamp}
                      selectedProductCode={selectedProductCode}
                    />
                  </Col>
                </Row>
              </div>
            </>
          ),
        },
      ]
      : [];

  let items = [...tabTypeAPI, ...tabsTypeDashboard];

  const { isDrawerOpen } = referencesWizardDrawer;
  return (
    <>
      <DisplayFormErrors />

      <Tabs
        style={{ width: "100%", height: "auto" }}
        defaultActiveKey="1"
        items={items}
      />

      {isDrawerOpen && (
        <UsersWizardsDrawer
          referencesUserWizardDrawer={referencesWizardDrawer}
          onCloseUsersWizardsDrawer={onCloseWizardsDrawer}
          onSelectUserWizardByUser={onSelectWizardByUser}
        />
      )}

      {false && <DebugForm />}
    </>
  );
};
